/**
 * @author slak4170
 * */
import {
  RECEIVE_COST_VIEW_DATA,
  RECEIVE_COST_VIEW_DETAILED_DATA,
  RECEIVE_MARGIN_INSIGHTS_HISTORY,
  RESET_COST_VIEW_DATA,
  UPDATE_COST_VIEW_PRESERVE_STATE,
} from '../actions/costViewActions';
import initialState from './initialState';

export default function costViewReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.costView;
  }

  if (type === RESET_COST_VIEW_DATA) {
    return {
      ...initialState.costView,
      isEmptyCostViewData: false
    };
  }

  if (type === RECEIVE_COST_VIEW_DATA) {
    return {
      ...state,
      costViewData: data,
      isEmptyCostViewData: !data || Object.keys(data).length === 0
    };
  }

  if (type === RECEIVE_COST_VIEW_DETAILED_DATA) {
    return {
      ...state,
      costViewDetailedData: data
    };
  }

  if (type === RECEIVE_MARGIN_INSIGHTS_HISTORY) {
    return {
      ...state,
      marginInsightsHistory: data
    };
  }

  if (type === UPDATE_COST_VIEW_PRESERVE_STATE) {
    return { ...state, preserve: data };
  }

  return state;
}
